export enum Partner {
  DEFAULT = 'default',
  JAMES_HARDIE = 'james-hardie',
  MUELLER = 'mueller',
  AMERIPRO = 'ameripro',
  HANSONS = 'hansons',
  INFINITY = 'infinity',
}
